/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import apiService from './index'

export const getAllHomeTags = async (userId: string) => {
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/tag/user/${userId}`)
}

export const getTagsByBoardId = async (boardId: string, type?: string) => {
  const query = type ? `?type=${type}` : ''
  return await apiService.get(`${process.env.REACT_APP_BACKEND_URL_V3}/tag/board/${boardId}${query}`)
}

export const createNewTag = async (name: string, boardId: string) => {
  return await apiService.post(`${process.env.REACT_APP_BACKEND_URL_V3}/tag`, {
    name: name,
    boardId: boardId,
  })
}
